/**
 * Shared utility for managing game history in localStorage.
 * Results are stored as JSON arrays per gameId.
 */

/**
 * Migrates data from the old "Modern Samurai" / "MSP" naming to the new "Modern Ninja" / "MNP" naming.
 */
export const migrateLegacySamuraiData = () => {
    try {
        // 1. History Migration: history_modern-samurai -> history_modern-ninja
        const oldHistory = localStorage.getItem('history_modern-samurai');
        if (oldHistory) {
            const newHistory = localStorage.getItem('history_modern-ninja');
            if (!newHistory || newHistory === "[]") {
                localStorage.setItem('history_modern-ninja', oldHistory);
                console.log("Migrated history_modern-samurai to history_modern-ninja");
            }
            localStorage.removeItem('history_modern-samurai');
        }

        // 2. Calibration Migration: msp_cal -> mnp_cal
        const oldCal = localStorage.getItem('msp_cal');
        if (oldCal) {
            if (!localStorage.getItem('mnp_cal')) {
                localStorage.setItem('mnp_cal', oldCal);
                console.log("Migrated msp_cal to mnp_cal");
            }
            localStorage.removeItem('msp_cal');
        }

        // 3. Earned Belt Migration: msp_earned_belt -> mnp_earned_belt
        const oldBelt = localStorage.getItem('msp_earned_belt');
        if (oldBelt) {
            if (!localStorage.getItem('mnp_earned_belt')) {
                localStorage.setItem('mnp_earned_belt', oldBelt);
                console.log("Migrated msp_earned_belt to mnp_earned_belt");
            }
            localStorage.removeItem('msp_earned_belt');
        }
    } catch (e) {
        console.error("Migration failed:", e);
    }
};


export const saveGameResult = (gameId, result) => {
    try {
        const history = JSON.parse(localStorage.getItem(`history_${gameId}`) || "[]");
        const sessionResult = {
            ...result,
            id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
            timestamp: new Date().toISOString()
        };
        history.push(sessionResult);
        // Keep last 1000 results to avoid localStorage bloat
        const limitedHistory = history.slice(-1000);
        localStorage.setItem(`history_${gameId}`, JSON.stringify(limitedHistory));
        return sessionResult;
    } catch (e) {
        console.error("Failed to save game result:", e);
        return null;
    }
};

export const getGameHistory = (gameId) => {
    try {
        return JSON.parse(localStorage.getItem(`history_${gameId}`) || "[]");
    } catch (e) {
        console.error("Failed to get game history:", e);
        return [];
    }
};

export const clearGameHistory = (gameId) => {
    localStorage.removeItem(`history_${gameId}`);
};

export const deleteGameResult = (gameId, resultId) => {
    try {
        const history = JSON.parse(localStorage.getItem(`history_${gameId}`) || "[]");
        const newHistory = history.filter(item => item.id !== resultId);
        localStorage.setItem(`history_${gameId}`, JSON.stringify(newHistory));
        return true;
    } catch (e) {
        console.error("Failed to delete game result:", e);
        return false;
    }
};

/**
 * Converts history to a CSV string for download or display.
 */
export const historyToCSV = (history) => {
    if (history.length === 0) return "";
    
    const headers = Object.keys(history[0]);
    const rows = history.map(item => 
        headers.map(header => {
            const val = item[header];
            return typeof val === 'string' && val.includes(',') ? `"${val}"` : val;
        }).join(',')
    );
    
    return [headers.join(','), ...rows].join('\n');
};
